"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
class PROMISE {
}
exports.default = PROMISE;
_a = PROMISE;
//? ---------------------- Static methods --------------------------------------------------------
PROMISE.wait = (ms) => __awaiter(void 0, void 0, void 0, function* () { return new Promise(resolve => setTimeout(resolve, ms)); });
PROMISE.batchRunner = (promises, batch_size = 2, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const results = [];
    const { remain_log = false, collect_result = false, throw_error = true } = options;
    try {
        for (let i = 0; i < promises.length; i += batch_size) {
            const ps = [];
            if (remain_log)
                console.log('remain', promises.length - i);
            for (let j = 0; j < batch_size; j++)
                ps.push((_b = promises === null || promises === void 0 ? void 0 : promises[i + j]) === null || _b === void 0 ? void 0 : _b.call(promises));
            for (let k = 0; k < ps.length; k++) {
                const r = yield (ps === null || ps === void 0 ? void 0 : ps[k]);
                if (collect_result && !!r)
                    results.push(r);
            }
        }
        return results;
    }
    catch (error) {
        console.log(`❌❌ PROMISE.batchRunner error : ${error}`);
        if (throw_error)
            throw error;
        return undefined;
    }
});
